<template>
  <div class="container-fluid mt-2">
    <h2>Aussendienst-Mitarbeiter</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <button id="new" @click="addUser()" class="btn btn-primary">Hinzuf&uuml;gen</button>
    </div>
    <b-table @row-clicked="openUser" class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(viewallcontacts)="data">
        <font-awesome-icon v-if="data.item.viewallcontacts" icon="check"/>
      </template>
    </b-table>
  </div>
</template>

<script>
import router from '@/router'
import ihanduser from '@/modules/ihanduser.js'

export default {
  name: 'iHandUserList',
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID'},
        { key: 'firstname', label: 'Vorname'},
        { key: 'lastname', label: 'Nachname'},
        { key: 'email', label: 'E-Mail' },
        { key: 'handid', label: 'Kennung' },
        { key: 'viewallcontacts', label: 'Alle Kunden' },
      ],
      rows: []
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      ihanduser.list(function(data) {
        console.log(data);
        self.rows = data.rows;
      })
    },
    openUser: function(row) {
      router.push({name: 'iHandUserEditor',params: {userid:row.id}});
    },
    addUser: function() {
      console.log('add user');
      router.push({name: 'iHandUserEditor',params: {userid: -1 }});
    },
    prevPage: function() {
      if (ihanduser.viewparams.page > 1) {
        ihanduser.viewparams.page--;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        ihanduser.viewparams.page++;
        this.fetchData();
      }
    },
  }
}
</script>
